// LoginModule.js
import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./LoginForm.css"; // Import the CSS file
import OtpForm from "./OtpForm";
import LoginForm from "./LoginForm";
import RagisterOtpForm from "./RagisterOtp";
import Freeplan from "./FreePlan";

const LoginModule = () => {
  return (
    <div className="container-fluid mainDiv">
      <div className="row loginBox">
            <div className="p-0 m-0" >
              <Routes>
                <Route path="/getOtp" element={<OtpForm />} />
                <Route path="/*" element={<LoginForm />} />
                <Route path="/freeplan" element={<Freeplan />} />
                <Route path="/registerdOtp" element={<RagisterOtpForm/>} />
              </Routes>
            </div>
          
      </div>
    </div>
  );
};

export default LoginModule;
